import { useApi } from "./useApi";
import { IAutoTradeLivePrice, adminApiServiceCommon } from "services/AdminApiService";

export function useAdminAutoTradePriceLookup (id: number) {
  const load = async (id: number) => {
    return await adminApiServiceCommon.getTradeLivePrices(id)
  }
  return useApi<IAutoTradeLivePrice, number>(load, id);
}
